import {
  collection,
  doc,
  DocumentData,
  query,
  QueryDocumentSnapshot,
  where,
} from "firebase/firestore";
import { db } from "@poseidon/firebase/firebase";
import { useEffect, useState } from "react";
import { useCollection } from "react-firebase-hooks/firestore";

export const useDealers = (verifiedOnly?: boolean, applicationId?: string) => {
  const [dealers, setDealers] = useState<DocumentData[]>([]);
  const [value, loading, error] = useCollection(
    query(
      collection(db, "dealers"),
      ...(verifiedOnly ? [where("isVerified", "==", true)] : [])
    )
  );
  const [applicationDealers, adLoading, adError] = useCollection(
    applicationId
      ? query(
          collection(db, "dealers"),
          ...(verifiedOnly
            ? [
                where(
                  "application",
                  "==",
                  doc(db, "applications", applicationId)
                ),
              ]
            : [])
        )
      : undefined
  );
  useEffect(() => {
    const run = async () => {
      if (value) {
        const docs = [...value.docs, ...(applicationDealers?.docs ?? [])].map(
          (doc) => mapDealer(doc)
        );
        setDealers(docs);
      }
    };
    run();
  }, [value, applicationDealers]);

  return { dealers, loading: loading || adLoading, error: error || adError };
};

const mapDealer = (snapshot: QueryDocumentSnapshot) => {
  if (!snapshot.exists()) {
    return {};
  }

  return {
    id: snapshot.id,
    documentReference: snapshot.ref,
    ...snapshot.data(),
  };
};
